// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SuggestedUserCard-cls1___5f0b087f65c47b27d43{/*!*/}.SuggestedUserCard-cls2___00490467095d0969bef{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;overflow:hidden;text-overflow:ellipsis;font-size:14px;font-weight:500;color:#223}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SuggestedUserCard-cls1___5f0b087f65c47b27d43",
	"cls2": "SuggestedUserCard-cls2___00490467095d0969bef SuggestedUserCard-cls1___5f0b087f65c47b27d43"
};
export default ___CSS_LOADER_EXPORT___;
